var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-select", {
    staticStyle: {
      width: "175px"
    },
    attrs: {
      multiple: _vm.multiple,
      filterable: "",
      placeholder: "请选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.someSelect();
      }
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  }, _vm._l(_vm.channelList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: _vm.getOptionLabel(item),
        value: item.id
      }
    });
  }), 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };